/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_SchedulerService_Dtos_GenericDropDownResponseDto } from '../models/Wealthlane_SchedulerService_Dtos_GenericDropDownResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AutomationConfigurationService {

    /**
     * @returns Wealthlane_SchedulerService_Dtos_GenericDropDownResponseDto OK
     * @throws ApiError
     */
    public static getApiSchedulerApiAppAutomationConfigurationExerciseAutomationList(): CancelablePromise<Array<Wealthlane_SchedulerService_Dtos_GenericDropDownResponseDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/scheduler/api/app/automation-configuration/exercise-automation-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_SchedulerService_Dtos_GenericDropDownResponseDto OK
     * @throws ApiError
     */
    public static getApiSchedulerApiAppAutomationConfigurationReleaseAutomationList(): CancelablePromise<Array<Wealthlane_SchedulerService_Dtos_GenericDropDownResponseDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/scheduler/api/app/automation-configuration/release-automation-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
